export const GOOGLE_CONTACTS_SCOPE =
  'https://www.googleapis.com/auth/contacts.readonly https://www.googleapis.com/auth/contacts.other.readonly';

export const PAGE_SIZE_OPTIONS = ['50', '100'];
